import { Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BranchService } from '../../services/branch.service';
import { NotificationService } from '../../../../core/services/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { DayTimeSlot } from '../day-time-slot/day-time-slot.component';
import * as moment from 'moment';
import {
  BranchDetailsMessage,
  OrdersMessages,
  productMessage,
} from 'app/pages/constants';

export interface DialogData {
  animal: string;
  name: string;
}

@Component({
  selector: 'app-time-slot-dialog',
  templateUrl: './time-slot-dialog.component.html',
  styleUrls: ['./time-slot-dialog.component.scss'],
})
export class TimeSlotDialogComponent {
  timeSlotForm: FormGroup;
  timeSlotHolidayForm: FormGroup;
  id: number;
  branchId: number;
  weekdays: boolean;
  dialogType: string;
  publicholidaysdelivery: any;
  publicholidayspickup: any;
  publicHolidayId: number;
  isstandardpickup: boolean;
  isalternatepickup: boolean;
  isstandarddelivery: boolean;
  isalternatedelivery: boolean;
  public today = new Date();
  public PublicHolidayArr: any;
  public tempArr: any = [];
  public deleteHolidayArray: any;
  public deleteHolidayPickupArray: any;
  public showHideTime: boolean;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<TimeSlotDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private branchService: BranchService,
    private notifyService: NotificationService,
    private translate: TranslateService
  ) {
    this.showHideTime = data.data.closeDay
    this.branchId = this.data.branchId;
    this.id = this.data.slotId;
    this.dialogType = this.data.dialogType;
    this.publicHolidayId = this.data.publicHolidayId;
    this.isstandardpickup = this.data.isstandardpickup;
    (this.isalternatepickup = this.data.isalternatepickup),
      (this.isstandarddelivery = this.data.isstandarddelivery),
      (this.isalternatedelivery = this.data.isalternatedelivery),
      this.getTimeSlote(this.id);
  }

  // ------------------------------------------------------------------------------------------------
  // @ Set form group key and if edit category - get detail by id
  // ------------------------------------------------------------------------------------------------
  ngOnInit() {
    this.timeSlotHoliday();
    this.initializeTimeslotForm();
  }
  public initializeTimeslotForm() {
    this.timeSlotForm = this.fb.group({
      uid: [''],
      title: ['', Validators.required],
      monday: [{ from: '', to: '', cutOff: '', slotInterval: '' }],
      tuesday: [{ from: '', to: '', cutOff: '', slotInterval: '' }],
      wednesday: [{ from: '', to: '', cutOff: '', slotInterval: '' }],
      thursday: [{ from: '', to: '', cutOff: '', slotInterval: '' }],
      friday: [{ from: '', to: '', cutOff: '', slotInterval: '' }],
      saturday: [{ from: '', to: '', cutOff: '', slotInterval: '' }],
      sunday: [{ from: '', to: '', cutOff: '', slotInterval: '' }],
    });
  }

  public timeSlotHoliday() {
    this.timeSlotHolidayForm = this.fb.group({
      uid: [''],
      title: ['', Validators.required],
      slot: [{
        from: '',
        to: '',
        cutOff: '',
        slotInterval: '',
      }],
      closeDay: [false],
      date: ['', Validators.required],
    });
  }

  checkCheckBoxvalue(event) {
    this.showHideTime = event.checked
  }

  conditionForHoliday(field1: any, field2: any) {
    // check if one field is required secound should be required
    if (
      !this.timeSlotHolidayForm.value[field1] &&
      !this.timeSlotHolidayForm.value[field2]
    ) {
      // if both null true
      this.timeSlotHolidayForm.get([field1])?.setErrors(null);
      this.timeSlotHolidayForm.get([field2])?.setErrors(null);
      this.weekdays = false;
    } else if (
      this.timeSlotHolidayForm.value[field1] &&
      this.timeSlotHolidayForm.value[field2]
    ) {
      // if both not null true
      this.timeSlotHolidayForm.get([field1]).setErrors(null);
      this.timeSlotHolidayForm.get([field2]).setErrors(null);
      var valid = this.dateValidator(
        this.timeSlotHolidayForm.value[field1],
        this.timeSlotHolidayForm.value[field2]
      );
      if (!valid) {
        // set custom error
        this.timeSlotHolidayForm.get([field2]).setErrors({
          invalid: this.translate.instant(OrdersMessages.to_invalid),
        });
        this.weekdays = true;
        return;
      }
      this.weekdays = false;
    } else if (
      this.timeSlotHolidayForm.value[field1] &&
      !this.timeSlotHolidayForm.value[field2]
    ) {
      // if second null
      this.timeSlotHolidayForm
        .get([field2])
        .setValidators([Validators.required]);
      this.timeSlotHolidayForm.get([field2]).updateValueAndValidity();
      this.weekdays = true;
    } else if (
      !this.timeSlotHolidayForm.value[field1] &&
      this.timeSlotHolidayForm.value[field2]
    ) {
      // if first null
      this.timeSlotHolidayForm
        .get([field1])
        ?.setValidators([Validators.required]);
      this.timeSlotHolidayForm.get([field1]).updateValueAndValidity();
      this.weekdays = true;
    } else {
      //both validate true
      this.timeSlotHolidayForm.get([field1]).setErrors(null);
      this.timeSlotHolidayForm.get([field2]).setErrors(null);
      this.weekdays = true;
    }
    //***** weekdays days true ? disable else enable mat-tab */
  }
  // ------------------------------------------------------------------------------------------------
  // @ If to_time should not greater then from_time
  // ------------------------------------------------------------------------------------------------
  dateValidator(fromTime, toTime) {
    var startTime = moment(fromTime, 'HH:mm a');
    var endTime = moment(toTime, 'HH:mm a');
    if (endTime <= startTime) {
      return false;
    } else {
      return true;
    }
  }

  onNoClick(data = [], res_id = null): void {
    this.dialogRef.close({ data: data, uid: res_id });
  }

  // ------------------------------------------------------------------------------------------------
  // @ If this is update form, get user details and update form group
  // ------------------------------------------------------------------------------------------------

  public parsedata(val: any) {
    if (val) {
      return JSON.parse(val);
    }
    return '';
  }
  getTimeSlote(index: number) {
    if (index) {
      this.branchService.getTimeSlote(index).subscribe(
        (response: any) => {
          this.publicholidaysdelivery = response.publicholidaysdelivery
            ? response.publicholidaysdelivery
            : '';
          this.publicholidayspickup = response.publicholidayspickup
            ? response.publicholidayspickup
            : '';
          this.branchService.publicholidaysdelivery =
            this.publicholidaysdelivery;
          this.branchService.publicholidayspickup = this.publicholidayspickup;
          this.branchService.standarddelivery = response.standarddelivery;
          this.branchService.standardpickup = response.standardpickup;
          this.branchService.alternatedelivery = response.alternatedelivery;
          this.branchService.alternatepickup = response.alternatepickup;
          this.deleteHolidayArray = this.parsedata(
            this.branchService.publicholidaysdelivery
          );
          this.deleteHolidayPickupArray = this.parsedata(
            this.branchService.publicholidayspickup
          );
          if (
            this.dialogType == 'openingTimesDeliveryStandard' &&
            response.standarddelivery
          ) {
            this.editOpeningTimesDeliveryPickup(
              JSON.parse(response.standarddelivery)
            ); // edit Opening Times Delivery-Pickup
          } else if (
            this.dialogType == 'openingTimesPickupStandard' &&
            response.standardpickup
          ) {
            this.editOpeningTimesDeliveryPickup(
              JSON.parse(response.standardpickup)
            ); // edit Opening Times Delivery-Pickup
          } else if (
            this.dialogType == 'openingTimesDeliveryAlternative' &&
            response.alternatedelivery
          ) {
            this.editOpeningTimesDeliveryPickup(
              JSON.parse(response.alternatedelivery)
            ); // edit Opening Times Delivery-Pickup
          } else if (
            this.dialogType == 'openingTimesPickupAlternative' &&
            response.alternatepickup
          ) {
            this.editOpeningTimesDeliveryPickup(
              JSON.parse(response.alternatepickup)
            ); // edit Opening Times Delivery-Pickup
          }

          if (this.publicHolidayId) {
            // if editable
            if (this.dialogType == 'openingTimesPublicHolidaysDelivery') {
              this.editPublicHoliday(
                JSON.parse(response.publicholidaysdelivery)
              );
            } else if (this.dialogType == 'openingTimesPublicHolidaysPickup') {
              this.editPublicHoliday(JSON.parse(response.publicholidayspickup));
            }
          }
        },
        (err) => {
          console.log(err);
          // this.errors = err;
        }
      );
    }
  }

  editOpeningTimesDeliveryPickup(res) {
    this.timeSlotForm.patchValue({
      title: res.title,
      monday: {
        from: res.openings[0].from,
        to: res.openings[0].to,
        cutOff: res.openings[0].cutOff,
        slotInterval: res.openings[0].slotInterval,
      },
      tuesday: {
        from: res.openings[1].from,
        to: res.openings[1].to,
        cutOff: res.openings[1].cutOff,
        slotInterval: res.openings[1].slotInterval,
      },
      wednesday: {
        from: res.openings[2].from,
        to: res.openings[2].to,
        cutOff: res.openings[2].cutOff,
        slotInterval: res.openings[2].slotInterval,
      },
      thursday: {
        from: res.openings[3].from,
        to: res.openings[3].to,
        cutOff: res.openings[3].cutOff,
        slotInterval: res.openings[3].slotInterval,
      },
      friday: {
        from: res.openings[4].from,
        to: res.openings[4].to,
        cutOff: res.openings[4].cutOff,
        slotInterval: res.openings[4].slotInterval,
      },
      saturday: {
        from: res.openings[5].from,
        to: res.openings[5].to,
        cutOff: res.openings[5].cutOff,
        slotInterval: res.openings[5].slotInterval,
      },
      sunday: {
        from: res.openings[6].from,
        to: res.openings[6].to,
        cutOff: res.openings[6].cutOff,
        slotInterval: res.openings[6].slotInterval,
      },
    });
  }

  editPublicHoliday(res) {
    // show editable public holiday

    let index = this.publicHolidayId - 1;
    this.timeSlotHolidayForm.patchValue({
      uid: this.publicHolidayId,
      title: res[index].title,
      slot: {
        from: res[index].from,
        to: res[index].to,
        cutOff: res[index].cutOff,
        slotInterval: res[index].slotInterval,
      },
      date: res[index].date,
      closeDay: res[index].closeDay,
    });
  }

  // ------------------------------------------------------------------------------------------------
  // @ When submit detail append formdata values. And callaccording to condition (Add/Update).
  // ------------------------------------------------------------------------------------------------

  submitForm(value: string) {
    if (this.showHideTime) {
      this.timeSlotHolidayForm.controls['slot'].setValue(null);
    }
    if (value == 'istimeSlotForm') {
      if (this.timeSlotForm.invalid) {
        this.timeSlotForm.markAllAsTouched();
        return;
      }
    } else {
      if (this.timeSlotHolidayForm.invalid) {
        this.timeSlotHolidayForm.markAllAsTouched();
        return;
      }
    }

    var formData = {
      uid: this.id,
      Title: this.timeSlotForm.value.title,
      mondayfrom: this.timeSlotForm.value.monday?.from,
      mondayTo: this.timeSlotForm.value.monday?.to,
      tuesdayfrom: this.timeSlotForm.value.tuesday?.from,
      tuesdayTo: this.timeSlotForm.value.tuesday?.to,
      wednesdayfrom: this.timeSlotForm.value.wednesday?.from,
      wednesdayTo: this.timeSlotForm.value.wednesday?.to,
      thursdayfrom: this.timeSlotForm.value.thursday?.from,
      thursdayTo: this.timeSlotForm.value.thursday?.to,
      fridayfrom: this.timeSlotForm.value.friday?.from,
      fridayTo: this.timeSlotForm.value.friday?.to,
      saturdayfrom: this.timeSlotForm.value.saturday?.from,
      saturdayTo: this.timeSlotForm.value.saturday?.to,
      sundayfrom: this.timeSlotForm.value.sunday?.from,
      sundayTo: this.timeSlotForm.value.sunday?.to,
      value: '',
      isstandardpickup: this.isstandardpickup,
      isalternatepickup: this.isalternatepickup,
      isstandarddelivery: this.isstandarddelivery,
      isalternatedelivery: this.isalternatedelivery,

      standarddelivery:
        this.dialogType == 'openingTimesDeliveryStandard'
          ? this.createFormattedArray('standarddelivery')
          : this.branchService.standarddelivery,
      standardpickup:
        this.dialogType == 'openingTimesPickupStandard'
          ? this.createFormattedArray('standardpickup')
          : this.branchService.standardpickup,
      alternatedelivery:
        this.dialogType == 'openingTimesDeliveryAlternative'
          ? this.createFormattedArray('alternatedelivery')
          : this.branchService.alternatedelivery,
      alternatepickup:
        this.dialogType == 'openingTimesPickupAlternative'
          ? this.createFormattedArray('alternatepickup')
          : this.branchService.alternatepickup,
      publicholidaysdelivery:
        this.dialogType == 'openingTimesPublicHolidaysDelivery'
          ? this.createPublicHolidayArray(
            eval(this.publicholidaysdelivery),
            'publicholidaysdelivery'
          )
          : this.publicholidaysdelivery,
      publicholidayspickup:
        this.dialogType == 'openingTimesPublicHolidaysPickup'
          ? this.createPublicHolidayArray(
            eval(this.publicholidayspickup),
            'publicholidayspickup'
          )
          : this.publicholidayspickup,
      dialogType: this.dialogType,
    };

    // return;

    if (this.id) {
      this.updateTimeSlote(formData);
    } else {
      this.addTimeSlote(formData);
    }
  }

  // form validations end

  // ------------------------------------------------------------------------------------------------
  // @ Add
  // ------------------------------------------------------------------------------------------------
  addTimeSlote(data) {
    this.branchService.addTimeSlote(data).subscribe(
      (response: any) => {
        if (response.success == true) {
          this.onNoClick(data, response.data.uid); // store result id
          this.notifyService.showSuccess(
            this.translate.instant(productMessage.add),
            this.translate.instant(OrdersMessages.success)
          );
        } else {
          this.notifyService.showError(
            response.message,
            this.translate.instant(OrdersMessages.error)
          );
        }
      },
      (err) => {
        //	this.errors = err;
      }
    );
  }

  // ------------------------------------------------------------------------------------------------
  // @ Update
  // ------------------------------------------------------------------------------------------------
  updateTimeSlote(data) {

    this.branchService.updateTimeSlote(data).subscribe(
      (response: any) => {
        if (response.success == true) {
          // updated
          this.onNoClick(data, this.id); // store result id
          this.notifyService.showSuccess(
            this.translate.instant(OrdersMessages.update),
            this.translate.instant(OrdersMessages.success)
          );
        } else {
          this.notifyService.showError(
            response.message,
            this.translate.instant(OrdersMessages.error)
          );
        }
      },
      (err) => {
        //  this.errors = err;
      }
    );
  }

  // ------------------------------------------------------------------------------------------------
  // @ Delete
  // ------------------------------------------------------------------------------------------------

  deleteTimeSlote(slotId: number) {
    if (confirm(this.translate.instant(OrdersMessages.confirmDelete))) {
      this.branchService.deleteTimeSlote(slotId).subscribe(
        (response: any) => {
          if (response.success == true) {
            // delete
            this.notifyService.showSuccess(
              this.translate.instant(OrdersMessages.delete),
              this.translate.instant(OrdersMessages.success)
            );
            this.onNoClick();
          } else if (
            response.success == false &&
            response.code ==
            BranchDetailsMessage.responseCode.timeslot_Associated
          ) {
            // Associate
            this.notifyService.showError(
              this.translate.instant(OrdersMessages.timeslotAssociated),
              this.translate.instant(OrdersMessages.error)
            );
          }
        },
        (err) => {
          // this.errors = err;
        }
      );
    } else {
      // Do nothing!
      console.log('Thing was not saved to the database.');
    }
  }

  public deletePublicHoliday(value: string, id: number) {
    console.log(id);
    if (value == 'openingTimesPublicHolidaysDelivery') {
      this.deleteHolidayArray = this.deleteHolidayArray.filter(
        (item) => item.id !== id
      );
      for (let i = 0; i < this.deleteHolidayArray.length; i++) {
        this.deleteHolidayArray[i].id = i + 1;
      }
    } else {
      this.deleteHolidayPickupArray = this.deleteHolidayPickupArray.filter(
        (item) => item.id !== id
      );
      for (let i = 0; i < this.deleteHolidayPickupArray.length; i++) {
        this.deleteHolidayPickupArray[i].id = i + 1;
      }
    }

    this.notifyService.showSuccess(
      this.translate.instant(OrdersMessages.delete),
      this.translate.instant(OrdersMessages.success)
    );

    var formData = {
      uid: this.id,
      Title: this.timeSlotForm.value.title,
      mondayfrom: this.timeSlotForm.value.mondayfrom,
      mondayTo: this.timeSlotForm.value.mondayTo,
      tuesdayfrom: this.timeSlotForm.value.tuesdayfrom,
      tuesdayTo: this.timeSlotForm.value.tuesdayTo,
      wednesdayfrom: this.timeSlotForm.value.wednesdayfrom,
      wednesdayTo: this.timeSlotForm.value.wednesdayTo,
      thursdayfrom: this.timeSlotForm.value.thursdayfrom,
      thursdayTo: this.timeSlotForm.value.thursdayTo,
      fridayfrom: this.timeSlotForm.value.fridayfrom,
      fridayTo: this.timeSlotForm.value.fridayTo,
      saturdayfrom: this.timeSlotForm.value.saturdayfrom,
      saturdayTo: this.timeSlotForm.value.saturdayTo,
      sundayfrom: this.timeSlotForm.value.sundayfrom,
      sundayTo: this.timeSlotForm.value.sundayTo,
      value: '',
      isstandardpickup: this.isstandardpickup,
      isalternatepickup: this.isalternatepickup,
      isstandarddelivery: this.isstandarddelivery,
      isalternatedelivery: this.isalternatedelivery,

      standarddelivery:
        this.dialogType == 'openingTimesDeliveryStandard'
          ? this.createFormattedArray('standarddelivery')
          : this.branchService.standarddelivery,
      standardpickup:
        this.dialogType == 'openingTimesPickupStandard'
          ? this.createFormattedArray('standardpickup')
          : this.branchService.standardpickup,
      alternatedelivery:
        this.dialogType == 'openingTimesDeliveryAlternative'
          ? this.createFormattedArray('alternatedelivery')
          : this.branchService.alternatedelivery,
      alternatepickup:
        this.dialogType == 'openingTimesPickupAlternative'
          ? this.createFormattedArray('alternatepickup')
          : this.branchService.alternatepickup,
      publicholidaysdelivery:
        this.dialogType == 'openingTimesPublicHolidaysDelivery'
          ? this.createPublicHolidayArray(
            eval(this.deleteHolidayArray),
            'publicholidaysdelivery'
          )
          : this.publicholidaysdelivery,
      publicholidayspickup:
        this.dialogType == 'openingTimesPublicHolidaysPickup'
          ? this.createPublicHolidayArray(
            eval(this.deleteHolidayPickupArray),
            'publicholidayspickup'
          )
          : this.publicholidayspickup,
      dialogType: this.dialogType,
    };

    this.updateTimeSlote(formData);
  }

  createPublicHolidayArray(ArrayData = [], type) {
    if (this.publicHolidayId) {
      // update existing record
      for (var i = 0; i < ArrayData.length; i++) {
        if (this.publicHolidayId == ArrayData[i].id) {
          this.PublicHolidayArr = {
            id: this.publicHolidayId,
            title: this.timeSlotHolidayForm.value.title,
            from: this.timeSlotHolidayForm.value.slot?.from ?? null,
            to: this.timeSlotHolidayForm.value.slot?.to ?? null,
            date: this.timeSlotHolidayForm.value.date,
            cutOff: this.timeSlotHolidayForm.value.slot?.cutOff ?? null,
            slotInterval: this.timeSlotHolidayForm.value.slot?.slotInterval ?? null,
            closeDay: this.timeSlotHolidayForm.value.closeDay,
          };

          this.tempArr.push(this.PublicHolidayArr);
        } else {
          this.tempArr.push(ArrayData[i]);
        }
      }
      this.PublicHolidayArr = this.tempArr;
    } else if (ArrayData?.length >= 1) {
      // add new in object
      var index = ArrayData.length + 1;
      var dataUpdate = {
        id: index,
        title: this.timeSlotHolidayForm.value.title,
        from: this.timeSlotHolidayForm.value.slot?.from,
        to: this.timeSlotHolidayForm.value.slot?.to,
        date: this.timeSlotHolidayForm.value.date,
        cutOff: this.timeSlotHolidayForm.value.slot?.cutOff,
        slotInterval: this.timeSlotHolidayForm.value.slot?.slotInterval,
        closeDay: this.timeSlotHolidayForm.value.closeDay,
      };
      ArrayData.push(dataUpdate);
      this.PublicHolidayArr = ArrayData;
    } else {
      // add first record
      this.PublicHolidayArr = [
        {
          id: 1,
          title: this.timeSlotHolidayForm.value.title,
          from: this.timeSlotHolidayForm.value.slot?.from,
          to: this.timeSlotHolidayForm.value.slot?.to,
          date: this.timeSlotHolidayForm.value.date,
          cutOff: this.timeSlotHolidayForm.value.slot?.cutOff,
          slotInterval: this.timeSlotHolidayForm.value.slot?.slotInterval,
          closeDay: this.timeSlotHolidayForm.value.closeDay,
        },
      ];
    }

    if (type == 'publicholidaysdelivery') {
      this.publicholidaysdelivery = JSON.stringify(this.PublicHolidayArr);
      this.branchService.publicholidaysdelivery = this.publicholidaysdelivery;
    } else if (type == 'publicholidayspickup') {
      this.publicholidayspickup = JSON.stringify(this.PublicHolidayArr);
      this.branchService.publicholidayspickup = this.publicholidayspickup;
    }
    return JSON.stringify(this.PublicHolidayArr);
  }

  // ------------------------------------------------------------------------------------------------
  // @ Create formatted array for timeslot calender on mobile app site
  // ------------------------------------------------------------------------------------------------

  isDayClosed(day: DayTimeSlot) {
    return !day?.from && !day?.to;
  }

  mapDay(day: DayTimeSlot) {
    const isValid = day?.from && day?.to;
    return {
      from: day.from,
      to: day.to,
      cutOff: (isValid) ? day.cutOff : null,
      slotInterval: (isValid) ? day.slotInterval : null,
      closed: this.isDayClosed(day),
    };
  }
  createFormattedArray(arrayType) {
    var weekDataArr = [
      {
        weekday: 1,
        weekday_formatted: 'monday',
        ...this.mapDay(this.timeSlotForm.value.monday),
      },
      {
        weekday: 2,
        weekday_formatted: 'tuesday',
        ...this.mapDay(this.timeSlotForm.value.tuesday),
      },
      {
        weekday: 3,
        weekday_formatted: 'wednesday',
        ...this.mapDay(this.timeSlotForm.value.wednesday),
      },
      {
        weekday: 4,
        weekday_formatted: 'thursday',
        ...this.mapDay(this.timeSlotForm.value.thursday),
      },
      {
        weekday: 5,
        weekday_formatted: 'friday',
        ...this.mapDay(this.timeSlotForm.value.friday),
      },
      {
        weekday: 6,
        weekday_formatted: 'saturday',
        ...this.mapDay(this.timeSlotForm.value.saturday),
      },
      {
        weekday: 7,
        weekday_formatted: 'sunday',
        ...this.mapDay(this.timeSlotForm.value.sunday),
      },
    ];

    if (weekDataArr.every(day => day.closed)) {
      return '';
    }

    var daysHeading = {
      title: this.timeSlotForm.value.title,
      openings: weekDataArr,
    };
    const json = JSON.stringify(daysHeading);
    if (arrayType == 'alternatedelivery') {
      this.branchService.alternatedelivery = json;
    } else if (arrayType == 'alternatepickup') {
      this.branchService.alternatepickup = json;
    } else if (arrayType == 'standarddelivery') {
      this.branchService.standarddelivery = json;
    } else if (arrayType == 'standardpickup') {
      this.branchService.standardpickup = json;
    }

    return json;
  }
}
